import { Badge } from 'reactstrap';
import { UnitPCVStatus } from '../enums/UnitPcvEnum';

interface Props {
  status: UnitPCVStatus;
  className?: string;
}

const statusConfig = {
  created: {
    label: 'Creado',
    color: 'default',
  },
  disabled: {
    label: 'Deshabilitado',
    color: 'danger',
  },
  taken: {
    label: 'Tomado',
    color: 'success',
  },
  available: {
    label: 'Disponible',
    color: 'success',
  },

  assigned: {
    label: 'Asignado',
    color: 'info',
  },
  on_deed: {
    label: 'Escriturado',
    color: 'default',
  },

  sold_external: {
    label: 'Vendido externo',
    color: 'warning',
  },

  transferred: {
    label: 'Transferido',
    color: 'default',
  },
  na: {
    label: 'N/A',
    color: 'secondary',
  },
};

const UnitPcvStatusBadge = ({ status, className }: Props) => {
  let config = statusConfig[status as UnitPCVStatus];
  if (!config) {
    config = statusConfig['na'];
  }
  return (
    <Badge color={config.color} className={className}>
      {config.label}
    </Badge>
  );
};

export { UnitPcvStatusBadge };
